/**
 * True when the error is the backend's "authenticated identity has no linked PCP account"
 * response (HTTP 403, errorCode 'no_linked_account'; pcp MultiJWTAuthenticator).
 * Shared so stores/user.ts and stores/permissionsStore.ts (DEVAMS-2760) cannot drift.
 */
export function isNoLinkedAccountError(error: unknown): boolean {
    const response = (error as { response?: { status?: number; data?: { errorCode?: string } } } | null | undefined)?.response;
    return response?.status === 403 && response.data?.errorCode === 'no_linked_account';
}
